import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  faxNumber: yup.string().required(),
});

export function useEfaxFavouriteUpdateMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.put(HTTP_ENDPOINTS.efax.updateFavourite(req.id), {
        name: req.name,
        faxNumber: req.faxNumber,
        templateId: req.templateId,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.efax.favourites],
        });

        options?.onSuccess?.(...args);
      },
    },
  );
}
